import { render } from "./OurLocations.vue?vue&type=template&id=606816b6&scoped=true"
import script from "./OurLocations.vue?vue&type=script&lang=js"
export * from "./OurLocations.vue?vue&type=script&lang=js"

import "./OurLocations.vue?vue&type=style&index=0&id=606816b6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/bmu-website/bmu-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606816b6"]])

export default __exports__